
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/art/[[...param]]",
      function () {
        return require("private-next-pages/art/[[...param]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/art/[[...param]]"])
      });
    }
  